import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

@Component
/**
 * SpecialSale Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Data to pass to list
     */
    @Prop() items!: Array<object>;

    /**
     * Endpoint to fetch data
     */
    @Prop() endpoint!: {[k: string]: any};

    /**
     * Version of the Images
     */
    @Prop({ type: String }) imageVersion!: string;

    /**
     * Color of component
     */
    @Prop({ type: String, default: 'primary' }) color!: string;
}
